import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface IApparel21Credentials {
    username: string,
    password: string,
    country_code: string,
    base_url: string,
}

class Apparel21CredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IApparel21Credentials = {} as IApparel21Credentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get username() { return this._changes.username; }
    public set username(v: string) { this._changes.username = v; }

    public get password() { return this._changes.password; }
    public set password(v: string) { this._changes.password = v; }

    public get countryCode() { return this._changes.country_code; }
    public set countryCode(v: string) { this._changes.country_code = v; }

    public get baseUrl() { return this._changes.base_url; }
    public set baseUrl(v: string) { this._changes.base_url = v; }
    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IApparel21Credentials;
    }

    public getUpdatedModel(): IApparel21Credentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default Apparel21CredentialsStore;
